"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const client_1 = require("@apollo/client");
const lodash_1 = require("lodash");
//
// assets
//
const customersCopy_1 = require("copy/customersCopy");
const graphql_1 = require("./graphql");
//
// components
//
const CustomerModal_1 = __importDefault(require("components/Dashboard/Modals/CustomerModal"));
//
// hooks
//
const useInfiniteScroll_1 = require("hooks/useInfiniteScroll");
const usePaginatedSearch_1 = __importDefault(require("components/usePaginatedSearch"));
const AccountContext_1 = require("contexts/AccountContext");
const DateFormat_1 = require("components/general/utility/DateFormat");
//
// styles
//
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const ErrorMessage_1 = require("./ErrorMessage");
const EmptyState_1 = require("./EmptyState");
const styles_1 = require("./styles");
const pageCount = 12;
const Customers = () => {
    var _a, _b, _c, _d, _e, _f;
    const { account } = (0, AccountContext_1.useAccount)();
    const [detailedCustomer, setDetailedCustomer] = react_1.default.useState({});
    const [showModal, setShowModal] = react_1.default.useState(false);
    const [getCustomers, { loading, data, fetchMore, error }] = (0, client_1.useLazyQuery)(graphql_1.GET_CUSTOMERS);
    const [searchQuery, setSearchQuery] = (0, react_1.useState)('');
    const { id: accountId } = account || {};
    // watch for account changes
    (0, react_1.useEffect)(() => {
        if (accountId) {
            getCustomers({ variables: { accountId, first: pageCount } });
        }
    }, [accountId]);
    const { searched, handleSearch, handleLoadNext } = (0, usePaginatedSearch_1.default)(fetchMore, 'customers', data);
    const debouncedHandleSearch = (0, react_1.useMemo)(() => (0, lodash_1.debounce)(handleSearch, 500), [handleSearch]);
    const onQueryChange = (0, react_1.useCallback)((query) => {
        setSearchQuery(query);
        debouncedHandleSearch(query);
    }, [debouncedHandleSearch]);
    (0, useInfiniteScroll_1.useInfiniteScroll)({
        hasNext: ((_b = (_a = data === null || data === void 0 ? void 0 : data.customers) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.hasNextPage) || false,
        loadNext: handleLoadNext
    });
    const handleToggleModal = (0, react_1.useCallback)(() => {
        setShowModal((current) => !current);
    }, [setShowModal]);
    const resourceName = {
        singular: 'customer',
        plural: 'customers'
    };
    const handleClearAll = (0, react_1.useCallback)(() => {
        handleSearch('');
    }, [handleSearch]);
    const customers = ((_d = (_c = data === null || data === void 0 ? void 0 : data.customers) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map(({ node }) => node)) || [];
    const rowMarkup = customers.map((customer, index) => {
        const customerFullName = `${customer.firstName} ${customer.lastName}`;
        return (react_1.default.createElement(polaris_1.IndexTable.Row, { id: customer.id, key: `customer:${customer.id}:${index}`, onClick: () => {
                setDetailedCustomer(customer);
                setShowModal(true);
            }, position: index },
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, customerFullName),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, customer.email || 'N/A'),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, DateFormat_1.shortDateFormat)(customer.insertedAt)),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                react_1.default.createElement(styles_1.StyledRightAlignedTableCell, null,
                    react_1.default.createElement(polaris_1.Button, { onClick: () => {
                            setDetailedCustomer(customer);
                            setShowModal(true);
                        } }, "Details")))));
    });
    return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'customers' },
        detailedCustomer && (react_1.default.createElement(CustomerModal_1.default, { customer: detailedCustomer, display: showModal, handleToggleModal: handleToggleModal })),
        react_1.default.createElement(styles_1.StyledHeaderContainer, null,
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, customersCopy_1.customersCopy.mainHeader)),
        react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(styles_1.TableFiltersContainer, null,
                react_1.default.createElement(polaris_1.Filters, { appliedFilters: [], filters: [], focused: searched, key: 'filters', onClearAll: handleClearAll, onQueryChange: onQueryChange, onQueryClear: () => onQueryChange(''), queryPlaceholder: 'Filter customers', queryValue: searchQuery })),
            react_1.default.createElement(polaris_1.IndexTable, { emptyState: error ? (react_1.default.createElement(ErrorMessage_1.ErrorMessage, null)) : (react_1.default.createElement(EmptyState_1.EmptyState, { hasFilters: searchQuery !== '', loading: loading })), headings: [
                    { title: 'Customer Name' },
                    { title: 'Email' },
                    { title: 'Added' }
                ], itemCount: customers.length, loading: loading, resourceName: resourceName, selectable: false }, rowMarkup)),
        ((_f = (_e = data === null || data === void 0 ? void 0 : data.customers) === null || _e === void 0 ? void 0 : _e.pageInfo) === null || _f === void 0 ? void 0 : _f.hasNextPage) && (react_1.default.createElement(styles_1.LoadMoreButtonContainer, null,
            react_1.default.createElement(polaris_1.Button, { id: 'load-more', onClick: handleLoadNext }, "Load More")))));
};
exports.default = Customers;
